// ============================================================================
// This file is MSN 2026 PROJECT SPECIFIC
// ============================================================================

// Registration Member Types
const initMemberTypes = () => {
  const countrySelect = document.getElementById("user_country");
  const memberTypeSelect = document.getElementById("user_member_type_id");

  if (!countrySelect || !memberTypeSelect) return;

  // Skip initialization if member type field is disabled (editing mode)
  if (memberTypeSelect.disabled) return;

  const memberTypes = JSON.parse(memberTypeSelect.dataset.memberTypes || "{}");

  function updateMemberTypeOptions() {
    const selectedCountryCode = countrySelect.value;

    // Clear existing options
    memberTypeSelect.innerHTML = '<option value="">- Select -</option>';

    if (!selectedCountryCode) {
      memberTypeSelect.disabled = true;
      return;
    }

    // Filter member types based on country rules
    Object.entries(memberTypes).forEach(([memberTypeName, memberTypeData]) => {
      const { id, country_rule, countries = [] } = memberTypeData;
      let shouldShow = false;

      switch (country_rule) {
        case "all_countries":
          shouldShow = true;
          break;
        case "specific_countries":
          shouldShow = countries.includes(selectedCountryCode);
          break;
        case "exclude_countries":
          shouldShow = !countries.includes(selectedCountryCode);
          break;
      }

      if (shouldShow) {
        const option = document.createElement("option");
        option.value = id;
        option.textContent = memberTypeName;
        memberTypeSelect.appendChild(option);
      }
    });

    memberTypeSelect.disabled = memberTypeSelect.options.length <= 1;
  }

  countrySelect.addEventListener("change", updateMemberTypeOptions);

  // Initialize on page load
  updateMemberTypeOptions();
};

// Initialize all custom functionality
const initMacro2026Registration = () => {
  initMemberTypes();
};

export default initMacro2026Registration;
